import { Icon } from './Icon';

/**
 * Passos de um assistente (cadastro de empresa, novo disparo).
 *
 * Mostra onde a pessoa esta e o que ja foi concluido. Os passos concluidos sao
 * clicaveis para voltar; os futuros nao, porque pular etapa deixaria campo
 * obrigatorio sem valor. Em tela estreita so o passo atual tem rotulo.
 */
export interface StepItem {
  readonly key: string;
  readonly label: string;
  readonly hint?: string;
}

export function Stepper({ steps, current, onGoTo }: { readonly steps: readonly StepItem[]; readonly current: number; readonly onGoTo?: (index: number) => void }): JSX.Element {
  return (
    <ol className="flex items-center gap-2 overflow-x-auto pb-1" aria-label="Etapas">
      {steps.map((step, index) => {
        const concluido = index < current;
        const atual = index === current;
        const clicavel = concluido && onGoTo !== undefined;
        return (
          <li key={step.key} className="flex shrink-0 items-center gap-2">
            <button
              type="button"
              disabled={!clicavel}
              onClick={clicavel ? () => onGoTo(index) : undefined}
              aria-current={atual ? 'step' : undefined}
              className={`flex items-center gap-2 rounded-full border py-1 pl-1 pr-3 text-xs font-medium transition-colors ${
                atual ? 'border-brand bg-brand/10 text-ink' : concluido ? 'border-status-good/40 text-ink-muted hover:bg-ink/5' : 'border-line text-ink-subtle'
              } ${clicavel ? '' : 'cursor-default'}`}
            >
              <span aria-hidden="true" className={`grid h-6 w-6 place-items-center rounded-full text-[11px] font-semibold ${atual ? 'bg-brand text-white' : concluido ? 'bg-status-good text-white' : 'bg-ink/10 text-ink-subtle'}`}>
                {concluido ? <Icon name="check" size="xs" /> : index + 1}
              </span>
              <span className={atual ? '' : 'hidden sm:inline'}>{step.label}</span>
            </button>
            {index < steps.length - 1 ? <span aria-hidden="true" className="h-px w-6 bg-line" /> : null}
          </li>
        );
      })}
    </ol>
  );
}
